import { request, errHandler, baseUrl } from "./heimdall";
import store from "../store";

export function getSiteTypes() {
  return request
    .get(`/types`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getSites() {
  return request
    .get(`/sites`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getSite(id) {
  return request
    .get(`/sites/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getSiteInType(id) {
  return request
    .get(`/sites/type/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function createSite(data) {
  return request
    .post("/sites/create", data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateSite(id, data) {
  return request
    .put(`/sites/update/${id}`, data, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function deleteSite(id) {
  return request
    .delete(`/sites/delete/${id}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function addUser(id, email) {
  return request
    .put(
      `/sites/${id}/user`,
      {
        email: email
      },
      {
        headers: {
          Authorization: store.getters.getToken
        }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}
/**
 * Remove a user from a site,
 * Here we use fetch as a replacement of Axio, because of a delete request with a body
 * @see https://github.com/axios/axios/issues/736
 * @param {Number} id The id of the site from which we need to remove the user
 * @param {String} email The email of the user to remove from the site
 */
export function removeUser(id, email) {
  return fetch(`${baseUrl}/sites/${id}/user`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: store.getters.getToken
    },
    body: JSON.stringify({
      email: email
    })
  })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function addEndpoint(url, integrityKey, siteId) {
  return request
    .post(
      `/endpoints/create/${siteId}`,
      {
        url: url,
        integrity_key: integrityKey
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function updateEndpoint(id, url, integrityKey, siteId) {
  return request
    .put(
      `/endpoints/update/${id}`,
      {
        url: url,
        integrity_key: integrityKey,
        site_id: siteId
      },
      {
        headers: { Authorization: store.getters.getToken }
      }
    )
    .then(({ data }) => data)
    .catch(errHandler);
}

export function removeEndpoint(id) {
  return request
    .delete(`/endpoints/delete/${id}`, {
      headers: { Authorization: store.getters.getToken }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

export function getLogs(id, scale, time) {
  return request
    .get(`/logs/${id}?time=${timeScale[scale] * time}`, {
      headers: {
        Authorization: store.getters.getToken
      }
    })
    .then(({ data }) => data)
    .catch(errHandler);
}

const timeScale = {
  year: 365 * 24 * 60 * 60 * 1000,
  month: 31 * 24 * 60 * 60 * 1000,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000
};
